<template>
  <div :class="segmentStyles">
    <div v-for="(x) in items"
         :style="{width:`${minWidth}px`}"
         :key="getValue(x)"
         :class="['smd-segment--item', getValue(x) == value ? 'selected' : undefined ]"
         @click="selectSegment(x)">{{ (x.label || x.name || x)}}</div>
  </div>
</template>

<script>
  export default {
    name: 'smd-segment',
    props: {
      items: { required: true },
      disabled: { type: Boolean, default: false },
      minWidth: { type: Number },
      type: { type: String, default: undefined },
      value: { required: true }
    },
    computed:{
      segmentStyles(){
        return [
          'smd-segment',
          this.disabled ? 'disabled': undefined,
          this.type
        ]
      }
    },
    methods: {
      getValue(option) {
        return typeof option === 'string'      ? option :
               typeof option.val === 'boolean' ? option.val :
                                                (option.val || option.id)
      },
      selectSegment(selected) {
        if (this.disabled) return false;

        const nextValue = this.getValue(selected);
        const hasChange = this.value !== nextValue;
        this.$emit('input', nextValue);

        if(hasChange) {
          this.$emit('change', nextValue);
          const ev = new Event('change', {bubbles: true});
          this.$el.dispatchEvent(ev);
        }
      },
    }
  }
</script>

<style lang="scss">

  @import "scss/pogs-util";

  .smd-segment {
    @extend %flex, %border-sides-radius-small, %align-items-stretch;
    cursor: pointer;

    padding: 0;
    margin: 0;

    height: 36px;

    & > label {
      margin-right: space(s);
    }

    &.pill,
    &.box{
      border: none;
      border-radius: 0;
      color: color(base);

      .smd-segment--item {
        @extend %flex-row--center-x, %justify-content-center;
        @include space-me($r: m, $l: m);

        background-color: transparent;
        border-color: color(label);

        font-weight: font(medium-bold);

        &:hover {
          border-color: color(darkest, border);
          color: color(dark);
          cursor: pointer !important;
          background-color: transparent;
        }

        &.selected {
          border-color: color(darkest, border);
          border-width: 2px;
          color: color(dark);
          background-color: transparent;
        }
      }
    }

    &.pill {

      height: 30px;

      .smd-segment--item {
        @extend %border-sides-radius-pilled;

        flex: initial;

        color: color(label);
        font-size: font(s) !important;
        text-transform: uppercase;

        margin-right: space(s);
      }

      &.solid {
        .smd-segment--item {
          border: none !important;
          background: color(hover);
          color: color(base);
          font-weight: font(medium-bold);

          &.selected {
            background-color: color(black);
            color: color(white);
          }

          &:last-child{
            margin-right: 0;
          }
        }
      }

      &.disabled{
        .smd-segment--item,
        .smd-segment--item:hover:not(.selected){
          border-color: color(base, border) !important;
          color: color(label);
        }
      }
    }

    &.box{
       align-content: stretch;

      .smd-segment--item {
        @extend %border-sides-radius-small;

        flex:1;

        &:not(:last-child){
          margin-right: space(m);
        }
      }
    }

    &:not(.pill):not(.box) > .smd-segment--item {
      list-style: none;
      flex: 1;
      font-size: font(s);

      display: flex;
      @extend %align-items-center, %justify-content-center;

      user-select: none;

      border: none;
      background-color: white;
      border-right: 1px solid color(dark, border);

      &:hover {
        background-color: color(hover);
      }

      &.selected {
        background-color: color(base);
        color: white;

        &:nth-last-child(1) {
          border-top-right-radius: radius(small) - 2px;
          border-bottom-right-radius: radius(small) - 2px;
        }

        &:nth-child(1) {
          border-top-left-radius: radius(small) - 2px;
          border-bottom-left-radius: radius(small) - 2px;
        }
      }

      &:nth-last-child(1) {
        border-right: none;

        border-top-right-radius: radius(small);
        border-bottom-right-radius: radius(small);
      }

      &:nth-child(1) {

        border-top-left-radius: radius(small);
        border-bottom-left-radius: radius(small);
      }
    }

    &.disabled {

      border-color: color(base, border);
      color: color(light);

      .smd-segment--item {

        border-right-color: color(base, border);

        &:hover {
          background-color: transparent;
        }

        &.selected {
          color: color(light);
          background-color: color(base, border);
        }
      }
    }
  }

</style>
